import { render, staticRenderFns } from "./PersonalSmartIdDetails.vue?vue&type=template&id=97096d26&"
import script from "./PersonalSmartIdDetails.vue?vue&type=script&lang=js&"
export * from "./PersonalSmartIdDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports